import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import IntlProvider from '../intl-provider';
import messages from './messages';
export var SwitchToTooltipText = /*#__PURE__*/React.createElement(IntlProvider, null, /*#__PURE__*/React.createElement(FormattedMessage, messages.switchSitesOrAppsTooltip));